/* eslint-disable */
import '@/libs/iziToast'
import '@/assets/styles/iziToast.css'
var noticeDefaultOption = {
  timeout: 30000,
  // position: 'center',
  pauseOnHover: true,
  // resetOnHover: true,
  close: true,
  layout: 2,
  // balloon: true,
  // target: '.target',
  // icon: 'material-icons',
  // iconText: 'face',
  // animateInside: false,
  position: 'topRight',
  transitionIn: 'bounceInLeft',
  progressBar: false,
  progressBarColor: '#43CB83',
  imageWidth: 20,
  url: '#',
  transitionOut: 'fadeOut',
  detailButtonText: null,
  closeButtonText: null
  // transitionOut: 'flipOutX',
}
iziToast.settings(noticeDefaultOption)

export default function notice(notice_style, option) {
  var setting_default = {
    timeout: option.timeout || noticeDefaultOption.timeout,
    title: option.title,
    message: option.message,
    url: option.url || noticeDefaultOption.url,
    progressBar: option.progressBar || noticeDefaultOption.progressBar,
    detailButtonText: option.detailButtonText || noticeDefaultOption.detailButtonText,
    closeButtonText: option.closeButtonText || noticeDefaultOption.closeButtonText
  }

  var baseOptions = { messageType: notice_style }
  switch (notice_style) {
    case 'info':
      iziToast.info(
        $.extend(baseOptions, setting_default, {
          progressBarColor: '#3390FF',
          image: '/images/icons/notice/info.svg'
        })
      )
      break
    case 'warning':
      iziToast.warning(
        $.extend(baseOptions, setting_default, {
          progressBarColor: '#3390FF',
          image: '/images/icons/notice/info.svg'
        })
      )
      break
    case 'success':
      iziToast.success(
        $.extend(baseOptions, setting_default, {
          image: '/images/icons/notice/success.svg',
          progressBarColor: '#43CB83'
        })
      )
      break
    case 'error':
      iziToast.error(
        $.extend(baseOptions, setting_default, {
          image: '/images/icons/notice/error.svg',
          progressBarColor: '#ED0028'
        })
      )
      break
  }
}
